export default __webpack_public_path__ + "static/media/brown.d78fee66.gif";